import React, { Fragment } from 'react';

const AboutUs = () => {
    return (
        <Fragment>
            <div className="container mt-5 text-center">
                <h1>About us</h1>
                <h2>Watch this space</h2>
            </div>
        </Fragment>
    );
}

export default AboutUs;